import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { IntegrationLogRequest } from "@/main/models/request";
import { IntegrationsLogDataResponse, IntegrationsLogFileResponse } from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IIntegrationLogApi {
	abstract getSearchGrid(
		request: IntegrationLogRequest,
	): Promise<AxiosResponse<PaginationResponse<IntegrationsLogDataResponse>>>;

	abstract getFile(
		idFile: string,
		idSystemApplication: number,
	): Promise<AxiosResponse<Result<IntegrationsLogFileResponse>>>;
}
